import { api } from "./base-config";
import { UserConfiguration } from "model/user-configuration.model";

/** ---- API CALLS ---- */
export const getUserConfiguration = async (
  userId: number
): Promise<UserConfiguration> => {
  return api
    .get(`/resources/secured/rs/users/${userId}/userConfiguration`)
    .then(response => response.data);
};

export const updateUserConfiguration = async (
  userId: number,
  userConfiguration: UserConfiguration
): Promise<UserConfiguration> => {
  const currentConfig = await getUserConfiguration(userId);
  const updated = { ...currentConfig, ...userConfiguration };
  return api
    .put(`/resources/secured/rs/users/${userId}/userConfiguration`, updated)
    .then(response => response.data);
};
